var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobeicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1941 49.9995C40.746 49.9995 50.9214 39.8242 50.9214 27.2722C50.9214 14.7203 40.746 4.54492 28.1941 4.54492C15.6422 4.54492 5.4668 14.7203 5.4668 27.2722C5.4668 39.8242 15.6422 49.9995 28.1941 49.9995Z",
    stroke: "#121212",
    strokeWidth: 3.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50391 15.9121H13.9888C15.4957 15.9121 16.9409 16.5107 18.0064 17.5763C19.072 18.6418 19.6706 20.087 19.6706 21.5939V24.2455C19.6707 25.1808 19.9016 26.1017 20.343 26.9263C20.7844 27.751 21.4226 28.4539 22.2009 28.9727L25.8297 31.3932C26.5579 31.8771 27.1551 32.5336 27.5682 33.3042C27.9814 34.0748 28.1975 34.9355 28.1975 35.8099C28.1975 36.6842 27.9814 37.545 27.5682 38.3155C27.1551 39.0861 26.5579 39.7426 25.8297 40.2265L16.2615 46.6053",
    stroke: "#121212",
    strokeWidth: 3.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8839 15.9121H45.2324C44.2636 15.9118 43.3109 16.1592 42.4648 16.6308C41.6186 17.1023 40.907 17.7824 40.3977 18.6064C39.8883 19.4304 39.5981 20.371 39.5546 21.3387C39.511 22.3064 39.7157 23.2692 40.149 24.1356C41.7664 27.3705 42.1376 27.5258 43.1414 28.128L50.3384 32.4386",
    stroke: "#121212",
    strokeWidth: 3.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeicon);
export default __webpack_public_path__ + "static/media/globeicon.4ed5678092174886be88a8fd067538fa.svg";
export { ForwardRef as ReactComponent };